import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const GetEvents = createAsyncThunk(
    '/GetEvents',
    async () => {
        let url = baseUrl+'GetEvents';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))
       
        if(response.data.status === "succes" || response.data.status === "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );




  


  

export const RegisterForEvent = createAsyncThunk(
    '/registerEvent',
    async (formData, { rejectWithValue }) => {
        const token      = Cookies.get("token");
        const company_id = Cookies.get("company_id");
        const member_id  = Cookies.get("userID");
        try {
            const response = await axios.post(
                baseUrl + 'registerEvent',
                { ...formData, company_id, member_id },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return Promise.resolve(response);
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const ValidateEventCoupon = createAsyncThunk(
    '/validateEventCoupon',
    async (payload, { rejectWithValue }) => {
        const token = Cookies.get("token");
        try {
            const response = await axios.post(
                baseUrl + 'validateEventCoupon',
                payload,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.data.status === "success") {
                return Promise.resolve({
                    success: true,
                    ...response.data.data
                });
            } else {
                return rejectWithValue(response.data.message || 'Invalid coupon');
            }
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

export const CheckRegistrationStatus = createAsyncThunk(
    '/checkRegistrationStatus',
    async (payload, { rejectWithValue }) => {
        const token = Cookies.get("token");
        try {
            const response = await axios.get(
                baseUrl + 'checkRegistrationStatus',
                { 
                    params: payload,
                    headers: { Authorization: `Bearer ${token}` } 
                }
            );
            return Promise.resolve(response.data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);
